module.exports = __webpack_public_path__ + "static/media/Donna-Jean Plante Headshot_1613547455921.0109eeb5.jpg";